var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 42"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21,
    r: 20.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.314 32.314A15.9 15.9 0 0 0 37 21c0-4.274-1.664-8.292-4.686-11.314A15.9 15.9 0 0 0 21 5 15.9 15.9 0 0 0 9.686 9.686 15.9 15.9 0 0 0 5 21c0 4.274 1.664 8.292 4.686 11.314A15.9 15.9 0 0 0 21 37c4.274 0 8.292-1.664 11.314-4.686M7.377 21c0-3.639 1.416-7.06 3.99-9.633A13.53 13.53 0 0 1 21 7.377c3.639 0 7.06 1.416 9.633 3.99A13.54 13.54 0 0 1 34.623 21c0 3.639-1.416 7.06-3.99 9.633A13.54 13.54 0 0 1 21 34.623c-3.639 0-7.06-1.416-9.633-3.99A13.54 13.54 0 0 1 7.377 21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.332 29c-.317 0-.635-.076-.93-.227L21 27.017l-3.403 1.756a2.01 2.01 0 0 1-2.098-.149 1.93 1.93 0 0 1-.793-1.913l.65-3.721-2.753-2.635a1.92 1.92 0 0 1-.504-2.005 1.97 1.97 0 0 1 1.608-1.332l3.805-.542 1.701-3.385A1.98 1.98 0 0 1 21 12c.764 0 1.448.418 1.787 1.09l1.701 3.386 3.805.543a1.97 1.97 0 0 1 1.608 1.33 1.92 1.92 0 0 1-.504 2.006l-2.753 2.635.65 3.72c.13.74-.174 1.473-.793 1.914a2 2 0 0 1-1.17.375"
  })));
};
export default SvgStar;